
































































































































































import Vue from 'vue'
import Component from 'vue-class-component'
import { PaymentsModule } from '@/store/modules/payments.module'
import { getModule } from 'vuex-module-decorators'
import Icon from '@/components/Icon.vue'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import Card from '@/components/Card.vue'
import Table from '@/components/tables/Table.vue'
import PaymentDepositsSubrow from '@/views/app/management/payments/components/PaymentDepositsSubrow.vue'
import { ETableColumnType, ITableConfig } from '@/interfaces'
import { EPccDepositError } from '@zunta/configurations'
import { getTooltipListText } from '@/utils/helpers'
import Confirm from '@/components/Confirm.vue'
import { formatDate } from '@/constants'
import ModalV2 from '@/components/modals/ModalV2.vue'

@Component({
  components: {
    ModalV2,
    PaymentDepositsSubrow,
    Table,
    Card,
    DateTimeLabel,
    Icon,
    Confirm
  }
})
export default class PaymentsDeposits extends Vue {
  paymentsModuleInstance: PaymentsModule = getModule(PaymentsModule, this.$store)

  openedRow: any
  openedRowIndex = -1

  update = 1
  tooltipTextCopied: string | null = null
  depositToMarkAsPosted: any | null = null
  postDepositInProgress: boolean = false

  getTooltipListText: Function = getTooltipListText

  config: ITableConfig = {
    clearFilterBtn: {
      wrapperClass: 'position-absolute',
      wrapperStyle: 'top: -1.5rem; right: -1.5rem;',
      class: 'rounded-top-bottom'
    },
    useQuery: true,
    usePagination: true,
    useSubrow: true,
    fetchFunction: this.paymentsModuleInstance.loadPccDeposits,
    rowClick: this.openPayments,
    maxHeight: 'calc(100vh - 392px)',
    minHeight: '100px',
    columns: [
      {
        minWidth: '140px',
        width: 10,
        key: 'willowId',
        searchKey: 'id',
        label: 'Deposit Id',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        minWidth: '120px',
        width: 15,
        key: 'chain',
        searchKey: 'chainName',
        label: 'Chain Name',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        minWidth: '120px',
        width: 15,
        key: 'profilesMerchantAccount',
        searchKey: 'profilesMerchantAccount',
        label: 'Facility Name',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        minWidth: '150px',
        width: 10,
        key: 'paymentMethodType',
        searchKey: 'paymentMethodType',
        label: 'Payment Type',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        headClass: 'bt-justify-content-end',
        class: 'text-right',
        minWidth: '100px',
        width: 12,
        key: 'amount',
        searchKey: 'amount',
        label: 'Amount',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.numberRange
      },
      {
        minWidth: '100px',
        width: 12,
        key: 'bankAccount',
        searchKey: 'bankAccount',
        label: 'Bank Account',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        minWidth: '170px',
        width: 17,
        key: 'depositDate',
        searchKey: 'depositDate',
        label: 'Deposit Date',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.dateRange
      },
      {
        minWidth: '150px',
        width: 25,
        key: 'login',
        searchKey: 'login',
        label: 'Log in  & Password',
        hasSort: true,
        hasSearch: true,
        type: ETableColumnType.default
      },
      {
        minWidth: '16px',
        width: 5,
        key: 'download',
        type: ETableColumnType.secondaryActions
      },
      {
        minWidth: '16px',
        width: 10,
        key: 'failedValidation',
        type: ETableColumnType.secondaryActions
      },
      {
        minWidth: '150px',
        width: 25,
        key: 'markDepositAsSync',
        type: ETableColumnType.secondaryActions
      }
    ]
  }

  get depositsList () {
    return this.$store.state.payments.pccDeposits.deposits
  }

  get recordsTotal () {
    return this.$store.state.payments.pccDeposits.total
  }

  get pluginData () {
    return this.$store.state.payments.pccDepositsDistribution
  }

  depositErrors (errors: EPccDepositError[]): string[] {
    if (!errors || !errors.length) {
      return []
    }

    const messages: string[] = []
    errors.forEach(error => {
      if (error === EPccDepositError.DEPOSIT_TOTAL) { messages.push('Payment amounts in this deposit don\'t total full deposit amount') }
      if (error === EPccDepositError.PAYMENT_TOTAL) { messages.push('The total payment amount does not match the applied transactions and convenience fees for one of the payments') }
      if (error === EPccDepositError.RESERVES) { messages.push('This deposit includes reserves') }
    })

    const missingInfoErrors = errors.filter(e => e.substring(0, e.indexOf('_')) === 'MISSING')
    if (missingInfoErrors && missingInfoErrors.length) {
      const missingInfo = missingInfoErrors.map(e => e.substring(e.indexOf('_') + 1).replace('_', ' ').toLowerCase())
      messages.push(`One or more payments in this deposit is missing information: ${missingInfo.join(', ')}`)
    }

    if (!messages.length) {
      messages.push('There are issues with the payments in this deposit.')
    }

    return messages
  }

  copyText (text: string, depositId: number, itemCopied: string) {
    navigator.clipboard.writeText(text)
    if (this.tooltipTextCopied !== `${depositId}-${itemCopied}`) {
      this.tooltipTextCopied = `${depositId}-${itemCopied}`
    }
  }

  getTooltipText (depositId: number, itemCopied: string) {
    if (this.tooltipTextCopied === `${depositId}-${itemCopied}`) {
      return 'Link Copied'
    }

    return 'Click to Copy'
  }

  openPayments (deposit: any, index: any) {
    if (index === this.openedRowIndex) {
      this.openedRowIndex = -1
      this.openedRow = null
      return
    }

    this.openedRowIndex = index
    this.openedRow = deposit
  }

  closePayments () {
    this.openedRowIndex = -1
    this.openedRow = null
  }

  copyPluginData () {
    navigator.clipboard.writeText(JSON.stringify(this.pluginData))
    this.tooltipTextCopied = null
  }

  downloadDeposit (depositId: number) {
    this.paymentsModuleInstance.downloadDepositForExport(depositId)
  }

  async created () {
    this.paymentsModuleInstance.loadPccDepositsDistribution()
    this.$socketManager.subscribeToPccDepositUpdates()
    this.$eventBus.$on('notifyPccDepositUpdate', this.paymentsModuleInstance.loadPccDeposits)
  }

  async markDepositAsPosted () {
    if (!this.depositToMarkAsPosted || !this.depositToMarkAsPosted.willowId) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: 'Deposit is not selected',
        header: `Error`,
        icon: 'warning'
      })
      this.depositToMarkAsPosted = null
      return
    }
    this.postDepositInProgress = true
    const response = await this.paymentsModuleInstance.markPCCDepositAsSync(this.depositToMarkAsPosted.willowId)
    if (response.status === 'Error') {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: response.error,
        header: `Error`,
        icon: 'warning'
      })
      this.depositToMarkAsPosted = null
      this.postDepositInProgress = false
      return
    }
    this.$eventBus.$emit('notify', {
      color: 'var(--status-success-color)',
      message: 'Deposit marked as posted',
      header: 'Success',
      icon: 'check'
    })
    this.postDepositInProgress = false
    this.depositToMarkAsPosted = null
    this.$eventBus.$emit('notifyPccDepositUpdate')
  }
}
